import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'sweetalert2/dist/sweetalert2.min.css';
import customAxios from './request'
import VueAxios from 'vue-axios'
import messages from './mixins/messageModals'
import VueClipboard from 'vue-clipboard2'
import VueSweetalert2 from 'vue-sweetalert2'
import VueFlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

Vue.use(VueFlatPickr);
Vue.use(VueSweetalert2)

VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)

Vue.use(VueAxios, customAxios)

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.mixin(messages)

Vue.config.productionTip = false

window.lokum = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
